module.exports = __webpack_public_path__ + "1a259fb78a1c9db14653cb9eabfa7b06.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/select-shapes/images/Asscher@2x.png
// module id = 315
// module chunks = 0